/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrUserEntity } from '../../models/dbr-user-entity';

export interface UsersControllerFindOne$Params {
  id: number;
}

export function usersControllerFindOne(http: HttpClient, rootUrl: string, params: UsersControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrUserEntity>> {
  const rb = new RequestBuilder(rootUrl, usersControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrUserEntity>;
    })
  );
}

usersControllerFindOne.PATH = '/users/{id}';
